module.exports = __webpack_public_path__ + "static/img/train_error.849636b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train_error.png
// module id = T1m+
// module chunks = 10